export default __webpack_public_path__ + "static/media/browse-musicians.ae72a816.svg";